<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import BaseCard from '@/components/shared/BaseCard.vue'

const { t } = useI18n()

const props = defineProps<{
  monthsWithPaymentsArray: Array<{ month: string; hasPayments: boolean }>
}>()

function mapDate(date: string): string {
  const monthStrings = ['Jan', 'Feb', 'Mar', 'Apr', 'Maí', 'Jun', 'Júl', 'Ágú', 'Sep', 'Okt', 'Nóv', 'Des']
  let month = date.split('-')[1]
  if (month.charAt(0) === '0') month = month.substring(1)
  return monthStrings[parseInt(month) - 1]
}
</script>

<template>
  <BaseCard>
    <div class="idgjold-container" :class="{ loading: !monthsWithPaymentsArray }">
      <h2 class="idgjold-title">{{ t('idgjaldarsida_stada') }}</h2>

      <div class="info-container">
        <div
          v-for="item in monthsWithPaymentsArray"
          :key="item.month"
          class="idjgald-box"
          :class="{ paid: item.hasPayments }"
        >
          {{ mapDate(item.month) }}
        </div>
      </div>
    </div>
  </BaseCard>
</template>

<style lang="scss">
.idgjold-container{
  display: flex;
  flex-direction: column;

  &.loading { opacity: .6; }
  &::-webkit-scrollbar { display: none; }

  h2{
    font-size: 24px;
    line-height: 32px;
    padding-bottom: 0px;
    margin-bottom: 0px;
  }

  .info-container{
    display: flex;
    flex-direction: row-reverse;
    justify-content: start;
    padding-top: 0px;
    margin-top: 0px;
    overflow-x: scroll;

    &::-webkit-scrollbar { display: none; }

    .idjgald-box{
      position: relative;
      width: 71px;
      height: 112px;
      border: 1px solid #E6E6E6;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      padding-bottom: 16px;
      font-weight: 600;

      &:before{
        content: '';
        position: absolute;
        top: 16px;
        height: 28px;
        width: 28px;
        background-image: url("@/assets/new-icons/unpaid.svg");
        background-repeat: no-repeat;
        background-size: contain;
      }
      &.paid:before{
        background-image: url("@/assets/new-icons/paid.svg");
      }
    }
  }

  @media (max-width: 900px ){
    padding: 0px;
    .info-container{
      .idgjald-box{
        height: 97px;
        width: 71px;
      }
    }
  }
}
</style>
